module.exports = __webpack_public_path__ + "img/blockchain_industry_01@2x.7d76976b.png";